module.exports = __webpack_public_path__ + "static/media/CopyUrlIcon.b5ed317b.svg";